import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Lock } from 'lucide-react';

const PreviewLimitOverlay = ({ message, onClose }) => {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 z-[9999] bg-black/90 flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center relative">
        {onClose && (
          <button
            onClick={onClose}
            className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
            aria-label="Cerrar"
          >
            <X className="w-5 h-5" />
          </button>
        )}
        <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <Lock className="w-8 h-8 text-amber-600" />
        </div>
        <h3 className="text-xl font-bold text-amber-900 mb-2">Se acabó tu vista previa gratis</h3>
        <p className="text-gray-600 mb-6">{message}</p>
        <button
          onClick={() => navigate('/suscripciones')}
          className="w-full px-6 py-3 bg-gradient-to-r from-amber-600 to-orange-600 hover:from-amber-700 hover:to-orange-700 text-white rounded-full font-semibold shadow-lg transition-all"
        >
          Ver planes de suscripción
        </button>
      </div>
    </div>
  );
};

export default PreviewLimitOverlay;
